import { create } from 'zustand';

interface AuthState {
  isAuthenticated: boolean;
  login: (username: string, password: string) => boolean;
  initialize: () => void;
}

const HARDCODED_USERNAME = 'ujeb';
const HARDCODED_PASSWORD = 'tlv2026';
const AUTH_STORAGE_KEY = 'ketzev-auth';

export const useAuthStore = create<AuthState>((set) => ({
  isAuthenticated: false,
  
  login: (username: string, password: string) => {
    if (username === HARDCODED_USERNAME && password === HARDCODED_PASSWORD) {
      set({ isAuthenticated: true });
      // Store in localStorage
      localStorage.setItem(AUTH_STORAGE_KEY, 'true');
      return true;
    }
    return false;
  },
  
  initialize: () => {
    // Check localStorage on app load
    const stored = localStorage.getItem(AUTH_STORAGE_KEY);
    if (stored === 'true') {
      set({ isAuthenticated: true });
    }
  },
}));

